export default __webpack_public_path__ + "static/media/arrow-right.d6ee9b7a.svg";